import type { State } from '@/typings/vuex';

export default function persistedItems(state: State): Partial<State> {
  return {
    company: state.company,
  };
}
